import React from "react";

export default function ContentDetails({ id, open, children }) {
  return (
    <div
      id={`${id}_segment_detail`}
      className={`segment-detail ${open ? "show" : ""}`}
    >
      <div className="content text-detail">{children}</div>
    </div>
  );
}
